import { callGet } from "../../lib/api-private";
import { GetPricingPlansResponse } from "generated-client/model/get-pricing-plans-response";

export const getPricingPlans = async (
  accessToken: string
): Promise<GetPricingPlansResponse> => {
  const data = await callGet(accessToken, "/pricing");
  return data;
};
